import React from 'react'
import {
  Link, Route, Routes, useLocation,
} from 'react-router-dom'
import {
  Button, Grid, makeStyles, Typography,
} from '@material-ui/core'
import Page from 'src/components/Page'
import { ArrowLeft, Gift } from 'react-feather'
import { useSelector } from 'react-redux'
import AdminList from './AdminList'
import EventForm from './Form'
import EditForm from './Edit'
import EventUsersList from './EventUsersList'
// import EventRefereeList from './EventRefereeList'
import EventRefereeUsers from './EventRefereeUsers'
// import RolesStep from './RolesStep'
// import RefereeEventsList from './RefereeEventsList'
import RefereeEventUsersList from './RefereeEventUsersList'
import RefereeEventComment from './RefereeEventComment'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: 10,
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
  },
  title: {
    marginBottom: 15,
  },
  giftIcon: {
    marginRight: 10,
  },
}))

export const Admin = () => {
  const classes = useStyle()
  const { pathname } = useLocation()
  const loggedInUser = useSelector((state) => state.user.role.roleId)

  return (
    <Page className={classes.root} title="رویداد ها">
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          {(pathname !== '/app/events/admin/user-event' && pathname !== '/app/events/admin/event-users/user')
          && <Typography variant="h3" component="h3"> رویداد ها</Typography>}

          {(loggedInUser !== 6 && loggedInUser !== 10) && (pathname === '/app/events/admin' && (loggedInUser === 2)
            ? (
              <div>
                <Link to="./add-event">
                  <Button startIcon={<Gift size={16} />} variant="contained" color="primary">
                    ایجاد رویداد جدید
                  </Button>
                </Link>
              </div>
            )
            : (
              <Link to="../admin">
                <Button>
                  بازگشت
                  <ArrowLeft />
                </Button>
              </Link>
            ))}
        </Grid>
        <Routes>
          <Route path="/" element={loggedInUser === 6 ? <RefereeEventUsersList /> : <AdminList />} />
          <Route path="/users" element={<EventRefereeUsers />} />
          <Route path="/event-users" element={<EventUsersList />} />
          {/* <Route path="/event-users/user" element={<EventRefereeList />} /> */}
          <Route path="/event-users/user/:id" element={<RefereeEventComment />} />
          <Route path="/referee-event-users" element={<RefereeEventUsersList />} />
          <Route path="/user-event" element={<RefereeEventComment />} />
          <Route path="/add-event" element={<EventForm />} />
          <Route path="/edit-event/:eventId" element={<EditForm />} />
        </Routes>
      </Grid>
    </Page>
  )
}

export default Admin
